"use client";

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@devhop/ui";
import type { WorkshopJobDetail } from "../api/client";
import { useAddWorkshopJobLaborMutation } from "../api/queries";
import { WorkshopAddLaborForm } from "./WorkshopAddLaborForm";

const ADD_LABOR_FORM_ID = "workshop-add-labor-form";

export function WorkshopLaborDialog({
  open,
  onOpenChange,
  shopId,
  job,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  shopId: string;
  job: WorkshopJobDetail;
}) {
  const addMut = useAddWorkshopJobLaborMutation(shopId);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[min(92vh,720px)] w-[calc(100%-1rem)] flex-col gap-0 overflow-hidden p-0 sm:max-w-lg">
        <DialogHeader className="shrink-0 space-y-1 border-border border-b px-4 py-4 sm:px-6">
          <DialogTitle className="text-base sm:text-lg">ເພີ່ມຄ່າແຮງ</DialogTitle>
          <DialogDescription className="text-left text-xs sm:text-sm">
            ໃບງານ {job.jobNumber} · {job.plateNumber}
          </DialogDescription>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-4 sm:px-6">
          <WorkshopAddLaborForm
            shopId={shopId}
            jobId={job.id}
            open={open}
            formId={ADD_LABOR_FORM_ID}
            onAdded={() => onOpenChange(false)}
          />
        </div>

        <DialogFooter className="shrink-0 gap-2 border-border border-t px-4 py-3 sm:px-6">
          <Button
            type="button"
            variant="outline"
            className="h-11 flex-1 sm:flex-none"
            disabled={addMut.isPending}
            onClick={() => onOpenChange(false)}
          >
            ຍົກເລີກ
          </Button>
          <Button
            type="submit"
            form={ADD_LABOR_FORM_ID}
            className="h-11 flex-1 sm:flex-none"
            disabled={addMut.isPending}
          >
            {addMut.isPending ? "ກຳລັງບັນທຶກ…" : "ເພີ່ມຄ່າແຮງ"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
